module.exports = __webpack_public_path__ + "img/Artboard 4.45d27cea.png";